import React from "react";
import { Card, Badge } from "react-bootstrap";
import { FaMicrophone } from "react-icons/fa";

const assistantKeyframes = `
@keyframes badgePulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
}
@keyframes shine {
  0% { left: -100%; }
  50% { left: 100%; }
  100% { left: 100%; }
}
`;

const AssistantButton = ({ data, className = "", typeLabel = "" }) => {
  const { utilisateur, exploitationActive, campagneActive } = data;

  const redirectToAIAssistant = () => {
    const getAssistantUrl = () => {
      const env = process.env.REACT_APP_ENV || 'staging';
      if (env === 'prod') {
        return "https://ceredoc-ia.netlify.app";
      }
      return "https://ceredoc-ia-staging.netlify.app";
    };

    const baseURL = getAssistantUrl();
    const params = new URLSearchParams({
      id_exploitation: exploitationActive.id,
      id_utilisateur: utilisateur.id,
      id_campagne: campagneActive.id,
    });
    window.location.href = `${baseURL}?${params.toString()}`;
  };

  return (
    <>
      <style>{assistantKeyframes}</style>
      <Card
        text="white"
        className={`shadow ${className}`}
        style={{
          cursor: "pointer",
          background: "linear-gradient(135deg, #28a745 0%, #20897a 100%)",
          border: "none",
          position: "relative",
          overflow: "hidden",
        }}
        onClick={redirectToAIAssistant}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "60%",
            height: "100%",
            background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)",
            transform: "skewX(-25deg)",
            animation: "shine 4s ease-in-out infinite",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />
        <Badge
          pill
          variant="warning"
          style={{
            position: "absolute",
            bottom: "6px",
            right: "8px",
            fontSize: "11px",
            fontWeight: "bold",
            color: "#333",
            padding: "5px 10px",
            animation: "badgePulse 1.5s ease-in-out infinite",
            zIndex: 1,
          }}
        >
          Nouveau !
        </Badge>
        <Card.Body className="d-flex align-items-center justify-content-center py-3">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mr-3"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              padding: "12px",
            }}
          >
            <FaMicrophone size={32} color="#fff" />
          </div>
          <div className="text-left">
            <div className="font-weight-bold" style={{ fontSize: "18px" }}>
              {typeLabel
                ? `Créez votre ${typeLabel.toLowerCase()} en 30s chrono`
                : "Créez vos interventions en 30s chrono"}
            </div>
            <small className="text-white" style={{ opacity: 0.9 }}>
              Nouvelle version — plus rapide, plus précis.
            </small>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default AssistantButton;
